import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { put, takeLatest, call } from 'redux-saga/effects';
import { REQUEST, FAILURE, SUCCESS } from 'helpers/constants';

import request from 'helpers/request';
import { types as typesNotification } from 'reducers/notification';

// Constants
export const types = {
  LIST_REQUEST: 'FORMAX/LIST_REQUEST',
  LIST_SUCCESS: 'FORMAX/LIST_SUCCESS',
  LIST_FAILURE: 'FORMAX/LIST_FAILURE',
};

// Actions
export const listFormaX = createAction(types.LIST_REQUEST);

const initialState = fromJS({
  list: {
    status: null,
    data: null,
  },
});

// Reducer
export default handleActions(
  {
    [types.LIST_SUCCESS]: (state, action) => {
      const newState = state.setIn(['list', 'status'], SUCCESS);
      return newState.setIn(['list', 'data'], fromJS(action.data));
    },
    [types.LIST_REQUEST]: state => state.setIn(['list', 'status'], REQUEST),
    [types.LIST_FAILURE]: (state, action) => {
      const newState = state.setIn(['list', 'status'], FAILURE);
      return newState.setIn(['list', 'data'], fromJS(action.data));
    },
  },
  initialState,
);

// sagas
function* listFormaXSaga({ payload }) {
  const response = yield call(request, {
    api: 'form/list-registers',
    method: 'POST',
    body: payload,
  });

  if (response.success) {
    yield put({ type: types.LIST_SUCCESS, data: response.body });
  } else {
    yield put({
      type: typesNotification.ADD,
      notification: {
        message: response.body,
        type: 'error',
      },
    });
    yield put({ type: types.LIST_FAILURE, data: response.body });
  }
}

export const listFormaXAsync = props => request({
  api: 'form/list-registers',
  method: 'POST',
  body: props,
});

export const listFormaXSorteoAsync = props => request({
  api: 'form/list-sorteo',
  method: 'POST',
  body: props,
});

export const formaXSagas = [
  takeLatest(types.LIST_REQUEST, listFormaXSaga),
];
